// extracted by mini-css-extract-plugin
export var modal = "_5b-0";